'use client';

var ENestedDatasetName;
(function (ENestedDatasetName) {
    ENestedDatasetName["JOB_FUNCTION"] = "jobFunction";
})(ENestedDatasetName || (ENestedDatasetName = {}));
var MobileSelectMode;
(function (MobileSelectMode) {
    MobileSelectMode[MobileSelectMode["Single"] = 0] = "Single";
    MobileSelectMode[MobileSelectMode["Multiple"] = 1] = "Multiple";
})(MobileSelectMode || (MobileSelectMode = {}));
// export type TTranslation = Record<string, string>
// export type TTranslatorFunction<T extends TTranslation> = ReturnType<typeof createTranslator<T>>
// export type TTranslatorFactoryProps<T extends TTranslation> = Parameters<typeof createTranslator<T>>
// export type TTranslatorFactory<T extends TTranslation> = typeof createTranslator<T>

export { ENestedDatasetName, MobileSelectMode };
//# sourceMappingURL=index.js.map
